import { render, staticRenderFns } from "./classes-layers.vue?vue&type=template&id=33d44ff6&"
import script from "./classes-layers.vue?vue&type=script&lang=js&"
export * from "./classes-layers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports